import React, { Fragment, useState, useEffect } from "react";
import clsx from "clsx";
import driverApi from "../../../apis/driverApi";

import styles from "./OrderList.module.scss";
import {
  HEADER_TABLE,
  PACKAGE_TYPE,
  PACKAGE_TYPE_VER_2,
  parseStatus,
  STATUS_TAB,
  paymentStatus,
  paymentMethod,
  colorPaymentStatus,
  colorPaymentMethod,
  parseShipperType,
  parseDonationForm,
} from "../../../constants/constant";
import { NEXT_PAGE, USER_DONATIONS } from "../../../global/type";
import dayjs from "dayjs";
import Loading from "../../Loading";
import ModalAddBag from "../ModalAddBag";
import PROVINCE from "../../../constants/province";
import DISTRICTS from "../../../constants/district";
import WARD from "../../../constants/ward";
import Button from "@mui/material/Button";
import ModalUpdatePaymentStatus from "../ModalUpdatePaymentStatus/ModalUpdatePaymentStatus";
import CreateOrderCode from "../../ProcessDelivery/CreateOrderCode";
import ModalUpdateNote from "../ModalUpdateNote/ModalUpdateNote";
import CreateOrderCodeDirect from "../../ProcessDelivery/CreateOrderCodeDirect";
import { useSnackbar } from "notistack";

export interface OrderListProps {
  className?: string;
  userDonations: USER_DONATIONS[];
  setDataRequest: (data: any) => void;
  dataRequest: any;
  handlePostDonationShipment: (id: string) => void;
  loading: boolean;
  handleCancelDonation: (id: string) => void;
  handleDoneDonation: (id: string) => void;
  setDataAddBag: any;
  dataAddBag: any;
  handleConfirmDonation: (id: string) => void;
  handleAddBag: any;
  handleChangeTab: (value: string[]) => void;
  selectedTab: string[];
  arrIndexShowmore: number[];
  handleShowMore: (index: number) => void;
  handleUpdatePaymentStatus: any;
  reload: () => void;
}

const ALLOWED_DONATION_FORMS: Record<string, string[]> = {
  "normal": ["charity", "cyclic_processing", "environmental_protection"],
  "recycle": ["extend_life_cycle", "buy_recycled_products", "donate_money"],
  "zero_waste": ["reduce_emissions", "energy_recovery"]
};

const OrderList = (props: OrderListProps) => {
  const {
    className,
    userDonations,
    loading,
    handlePostDonationShipment,
    handleConfirmDonation,
    handleCancelDonation,
    handleDoneDonation,
    setDataAddBag,
    dataAddBag,
    handleAddBag,
    handleChangeTab,
    selectedTab,
    arrIndexShowmore,
    handleShowMore,
    handleUpdatePaymentStatus,
    reload,
  } = props;

  const [open, setOpen] = useState(false);
  const [isOpenUpdatePayment, setIsOpenUpdatePayment] = useState(false);
  const [dataUpdatePayment, setDataUpdatePayment] = useState({});
  const [isOpenUpdateNote, setIsOpenUpdateNote] = useState(false);
  const [dataUpdateNote, setDataUpdateNote] = useState({});
  const [drivers, setDrivers] = useState<any[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const partnerId = process.env.REACT_APP_ENV === "production" ? "01G486CQAV7VW2FK3DHZV1T2FG" : "01G4866BBJGYR1JH8E6RPYEW2C";
    driverApi.listDrivers(partnerId).then((res) => {
      if (res.data?.code === 0 && res.data?.data) {
        setDrivers(res.data.data);
      }
    }).catch(() => {});
  }, []);

  const getDriverInfo = (driverId?: string) => {
    if (!driverId) return null;
    const found = drivers.find((d) => d.id === driverId);
    return found ? { name: found.name, phone: found.phone } : { name: `ID: ${driverId.slice(-6)}`, phone: "" };
  };

  const getOrderIncome = (item: any): number => {
    if (item.driverIncome !== undefined && item.driverIncome !== null && typeof item.driverIncome === "number") {
      return item.driverIncome;
    }
    try {
      const storedConfigs = JSON.parse(localStorage.getItem("driver_order_incomes") || "{}");
      const conf = storedConfigs[item.id];
      if (conf?.calculatedIncome !== undefined && conf?.calculatedIncome !== null) {
        return Number(conf.calculatedIncome);
      }
    } catch (e) {}
    return 0;
  };

  const handleOpenModal = (donationId: string, customerNote: string) => {
    setIsOpenUpdateNote(true);
    setDataUpdateNote({
      ...dataUpdateNote,
      donationId: donationId,
      note: customerNote,
    });
  };

  const handleOpen = (donation_id: string) => {
    setOpen(true);
    setDataAddBag({
      ...dataAddBag,
      donation_id: donation_id,
    });
  };
  const handleClose = () => setOpen(false);
  const handleOpenModalUpdatePayment = (
    donation_id: string,
    status: string
  ) => {
    setIsOpenUpdatePayment(true);
    setDataUpdatePayment({
      donationId: donation_id,
      status: status,
    });
  };

  const handleCloseUpdatePayment = () => setIsOpenUpdatePayment(false);
  const parseAddress = (address: any) => {
    const province = PROVINCE.find(
      (p: any) => p.code === address?.provinceID
    ) || { label: "" };

    const district = DISTRICTS.find(
      (d: any) => d.code === address?.districtID
    ) || { name: "" };

    const ward = WARD.find((w: any) => w.code === address?.wardID) || {
      name: "",
    };

    return `${address?.address}, ${ward.name}, ${district.name}, ${province.label}`;
  };

  const copyInfoOrder = (item: any) => {
    const customerAddress = parseAddress(item?.customerAddress);
    const createdAt = dayjs(item.createdAt).format("DD/MM/YYYY");
    const shippingType =
      item?.shippingType === "shipper" 
        ? "Shipper đến lấy" 
        : item?.shippingType === "station"
        ? "Gửi tại các trạm thu gom của REshare"
        : "Giao tại kho";
    const collectDate = dayjs(item?.collectDate).format("DD/MM/YYYY");
    const deliveryTime = `${item?.collectFromTime?.slice(
      0,
      5
    )} - ${item?.collectToTime?.slice(0, 5)}`;
    const packageType = PACKAGE_TYPE.find(
      (p: any) => p.packageType === item?.packageType
    )?.label;
    const promotion = item?.promotionalPrice?.toLocaleString("vi");
    const shippingPrice = item?.shippingPrice?.toLocaleString("vi");
    const totalPrice = item?.totalPrice?.toLocaleString("vi");

    const shippingTypeAddress = parseAddress(item?.shippingTypeAddress);
    const contentCopy = `
      Mã đơn hàng: ${item.code}
      Tên khách hàng: ${item.customerName}
      Số điện thoại: ${item.customerPhone}
      Email: ${item.customerEmail}
      Địa chỉ: ${customerAddress}
      Ngày đặt hàng: ${createdAt}
      Hình thức vận chuyển: ${shippingType}
      Ngày dự kiến nhận hàng: ${collectDate}
      Thời gian giao hàng: ${deliveryTime}
      Trọng lượng hàng: ${packageType}
      Trạng thái thanh toán: ${paymentStatus(item.paymentStatus)}
      Khuyến mãi: ${promotion} VNĐ
      Giá ship: ${shippingPrice} VNĐ
      Tổng tiền: ${totalPrice} VNĐ
      Kho nhận hàng: ${shippingTypeAddress}
    `;
    navigator.clipboard.writeText(contentCopy);
    enqueueSnackbar("Đã sao chép!", { variant: "success" });
  };

  return (
    <div className={clsx(styles.root, className && className)}>
      <div className={styles.orderListWrap}>
        <div className={styles.statusTab}>
          <div className={styles.statusTabItem}>
            {STATUS_TAB.map((item) => {
              return (
                <div
                  onClick={() => handleChangeTab(item.value)}
                  key={item.id}
                  className={clsx(
                    styles.statusTabItemTitle,
                    selectedTab === item.value && styles.active
                  )}
                >
                  {item.title}
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.orderList}>
          <table className={styles.orderListTable}>
            <thead>
              <tr>
                <Fragment>
                  <th></th>
                </Fragment>
                {HEADER_TABLE.map((item) => {
                  return <th key={item.id}>{item.title}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {userDonations?.length > 0 ? (
                userDonations?.map((item, index) => {
                  return (
                    <Fragment key={index}>
                      <tr
                        className={clsx(
                          styles.item,
                          arrIndexShowmore.includes(index) && styles.active
                        )}
                        key={item.id}
                        onClick={() => handleShowMore(index)}
                      >
                        <td className={clsx(styles.iconWrap)}>
                          {arrIndexShowmore.includes(index) ? (
                            <img src="/images/show.svg" alt="" />
                          ) : (
                            <img src="/images/hide.svg" alt="" />
                          )}
                        </td>
                        <td>{item.code}</td>

                        <td>{parseAddress(item?.customerAddress)}</td>

                        <td>
                          {item?.order_bags?.map((bag: any) => {
                            return (
                              <Fragment>
                                <div className={styles.bagId}>{bag.id}</div>
                              </Fragment>
                            );
                          })}
                        </td>

                        <td>
                          {(item.status === "new" ||
                            item.status === "confirm" ||
                            item.status === "processing") && (
                            <Button onClick={() => handleOpen(item.id)}>
                              Thêm túi
                            </Button>
                          )}
                        </td>
                        <td>
                          {item?.donationForms &&
                            item?.donationForms.length > 0 &&
                            item.donationForms.map((item: any, key: any) => {
                              return <p key={key}>{parseDonationForm(item)}</p>;
                            })}
                        </td>
                        <td>
                          {item?.shippingType === "shipper"
                            ? `Shipper đến lấy (${parseShipperType(
                                item?.shipperType
                              )})`
                            : item?.shippingType === "station"
                            ? "Gửi tại các trạm thu gom của REshare"
                            : "Giao tại kho"}
                          <div>
                            {item?.shippingType === "shipper" &&
                              item.status !== "new" && (
                                <CreateOrderCode
                                  {...item}
                                  reload={props.reload}
                                />
                              )}
                            {item?.shippingType !== "shipper" &&
                              item.status !== "new" && (
                                <CreateOrderCodeDirect
                                  {...item}
                                  reload={props.reload}
                                />
                              )}
                          </div>
                        </td>
                        <td>
                          {item?.totalPrice?.toLocaleString("vi")}
                        </td>
                        <td>{parseStatus(item.status)}</td>
                        <td>
                          <p>{item.customerNote}</p>
                          <Button
                            style={{ marginTop: "10px" }}
                            onClick={() =>
                              handleOpenModal(item.id, item.customerNote)
                            }
                            variant="contained"
                            size="small"
                          >
                            Cập nhật
                          </Button>
                        </td>
                        <td
                          style={{
                            color: colorPaymentMethod(item.paymentMethod),
                          }}
                        >
                          {paymentMethod(item.paymentMethod)}
                        </td>
                        <td
                          style={{
                            color: colorPaymentStatus(item.paymentStatus),
                          }}
                        >
                          {paymentStatus(item.paymentStatus)}
                          {item.status !== "done" &&
                            item.status !== "cancel" && (
                              <Button
                                style={{ marginTop: "10px" }}
                                variant="contained"
                                size="small"
                                onClick={() =>
                                  handleOpenModalUpdatePayment(
                                    item.id,
                                    item.paymentStatus
                                  )
                                }
                              >
                                Cập nhật
                              </Button>
                            )}
                        </td>
                        <td>
                          {dayjs(item.createdAt).format("DD/MM/YYYY HH:mm")}
                        </td>
                        <td>
                          {dayjs(item.updatedAt).format("DD/MM/YYYY HH:mm")}
                        </td>
                        {item.status !== "cancel" && item.status !== "done" && (
                          <td className={styles.tdAction}>
                            {item.status !== "processing" &&
                              item.status !== "confirm" && (
                                <Button
                                  variant="contained"
                                  color="success"
                                  onClick={() => handleConfirmDonation(item.id)}
                                >
                                  Xác nhận
                                </Button>
                              )}

                            {item.status !== "processing" &&
                              item.status !== "new" &&
                              item.status !== "pending" && (
                                <Button
                                  color="secondary"
                                  onClick={() =>
                                    handlePostDonationShipment(item.id)
                                  }
                                >
                                  Cập nhật
                                </Button>
                              )}

                            {item.status !== "new" &&
                              item.status !== "confirm" &&
                              item.status !== "pending" && (
                                <Button
                                  variant="contained"
                                  color="success"
                                  onClick={() => handleDoneDonation(item.id)}
                                  size="small"
                                >
                                  Hoàn thành
                                </Button>
                              )}

                            <Button
                              variant="outlined"
                              color="error"
                              onClick={() => handleCancelDonation(item.id)}
                              size="small"
                            >
                              Huỷ
                            </Button>
                          </td>
                        )}
                      </tr>
                      {arrIndexShowmore.includes(index) && (
                        <tr className={styles.itemDetail}>
                          <td
                            colSpan={HEADER_TABLE.length + 1}
                            className={styles.itemDetailWrap}
                          >
                            <table>
                              <thead>
                                <tr>
                                  <th>
                                    Thông tin{" "}
                                    <img
                                      onClick={() => copyInfoOrder(item)}
                                      className={styles.copy}
                                      src="/images/copy.png"
                                      alt="Copy"
                                    />
                                  </th>
                                  <th>Dịch vụ / Sản phẩm</th>
                                  <th>Hình túi đồ</th>
                                  <th>Ảnh giao nhận (Tài xế)</th>
                                </tr>
                              </thead>

                              <tbody>
                                <tr>
                                  <td className={styles.itemDetailInfoWrap}>
                                    <div className={styles.itemDetailInfo}>
                                      <p>Tên khách hàng: {item.customerName}</p>

                                      <p>Số điện thoại: {item.customerPhone}</p>

                                      <p>Email: {item?.customerEmail}</p>

                                      <p>
                                        Địa chỉ:{" "}
                                        {parseAddress(item?.customerAddress)}
                                      </p>

                                      <p>
                                        Ngày đặt hàng:{" "}
                                        {dayjs(item.createdAt).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </p>

                                      <p>
                                        Hình thức vận chuyển:{" "}
                                        {item?.shippingType === "shipper"
                                          ? "Shipper đến lấy"
                                          : item?.shippingType === "station"
                                          ? "Gửi tại các trạm thu gom của REshare"
                                          : "Giao tại kho"}
                                      </p>

                                      {(() => {
                                        const drInfo = getDriverInfo(item.driverId);
                                        const income = getOrderIncome(item);
                                        return (
                                          <div
                                            style={{
                                              background: "#f0fdf4",
                                              border: "1px solid #bbf7d0",
                                              padding: "8px 10px",
                                              borderRadius: 6,
                                              margin: "8px 0",
                                            }}
                                          >
                                            <p style={{ margin: 0, fontWeight: 600, color: "#166534" }}>
                                              🚗 Tài xế phụ trách:{" "}
                                              <span style={{ fontWeight: 700 }}>
                                                {drInfo ? `${drInfo.name} ${drInfo.phone ? `(${drInfo.phone})` : ""}` : "Chưa gán"}
                                              </span>
                                            </p>
                                            <p style={{ margin: "4px 0 0 0", color: "#15803d", fontWeight: 600 }}>
                                              💰 Thù lao tài xế:{" "}
                                              <span style={{ fontSize: 15, fontWeight: 700, color: "#16a34a" }}>
                                                {income > 0 ? `+${income.toLocaleString("vi")} VNĐ` : "Chưa thiết lập"}
                                              </span>
                                            </p>
                                          </div>
                                        );
                                      })()}

                                      <p>
                                        Ngày dự kiến nhận hàng:{" "}
                                        {dayjs(item?.collectDate).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </p>

                                      <p>
                                        Thời gian giao hàng:{" "}
                                        {item?.collectFromTime?.slice(0, 5)} -
                                        {item?.collectToTime?.slice(0, 5)}
                                      </p>

                                      <p>
                                        {item.services && item.services.length > 0 ? "Tổng trọng lượng túi đồ: " : "Trọng lượng hàng: "}
                                        {(() => {
                                          if (!item.services || item.services.length === 0) {
                                            const rootPt = item?.packageType;
                                            const foundRoot = PACKAGE_TYPE.find((p: any) => p.packageType === rootPt);
                                            const foundRoot2 = PACKAGE_TYPE_VER_2.find((p: any) => p.packageTypeId === rootPt);
                                            return foundRoot?.label || foundRoot2?.label || rootPt;
                                          }
                                        
                                          let totalMin = 0;
                                          let totalMax = 0;
                                          let hasValidWeight = false;
                                        
                                          item.services.forEach((svc: any) => {
                                            const pt = svc.packageType || (svc as any).package_type;
                                            const pId = (svc as any).packageTypeId || (svc as any).packageTypeID;
                                            let label = "";
                                            if (pt) {
                                              label = PACKAGE_TYPE.find((p: any) => p.packageType === pt)?.label || pt;
                                            } else if (pId) {
                                              label = PACKAGE_TYPE_VER_2.find((p: any) => p.packageTypeId === pId)?.label || pId;
                                            }
                                            
                                            if (label) {
                                              const nums = label.match(/\d+/g);
                                              if (nums && nums.length >= 2) {
                                                totalMin += parseInt(nums[0], 10);
                                                totalMax += parseInt(nums[1], 10);
                                                hasValidWeight = true;
                                              }
                                            }
                                          });
                                        
                                          if (hasValidWeight) {
                                            return `${totalMin} đến ${totalMax} kg`;
                                          }
                                          
                                          // fallback
                                          const rootPt = item?.packageType;
                                          const foundRoot = PACKAGE_TYPE.find((p: any) => p.packageType === rootPt);
                                          const foundRoot2 = PACKAGE_TYPE_VER_2.find((p: any) => p.packageTypeId === rootPt);
                                          return foundRoot?.label || foundRoot2?.label || rootPt;
                                        })()}
                                      </p>

                                      <p>
                                        Trạng thái thanh toán:{" "}
                                        <span style={{ color: colorPaymentStatus(item.paymentStatus) }}>
                                          {paymentStatus(item.paymentStatus)}
                                        </span>
                                      </p>

                                      <p>
                                        Khuyến mãi:{" "}
                                        {item?.promotionalPrice?.toLocaleString(
                                          "vi"
                                        )}{" "}
                                        VNĐ
                                      </p>
                                      <p>
                                        Phí xử lí:{" "}
                                        {item?.zeroWastePrice?.toLocaleString(
                                          "vi"
                                        )}{" "}
                                        VNĐ
                                      </p>

                                      <p>
                                        Sản phẩm tái chế:{" "}
                                        {(item?.services?.reduce((total, svc) => total + (svc.buyProducts?.reduce((sum, p) => sum + (p.price * p.quantity), 0) || 0), 0) || 0).toLocaleString("vi")}{" "}
                                        VNĐ
                                      </p>
                                      <p>
                                        Giá ship:{" "}
                                        {item?.shippingPrice?.toLocaleString(
                                          "vi"
                                        )}{" "}
                                        VNĐ
                                      </p>

                                      <p>
                                        Đồng hành ủng hộ:{" "}
                                        {(item?.services?.reduce((total, svc) => total + (svc.donationAmount || 0), 0) || 0).toLocaleString("vi")}{" "}
                                        VNĐ
                                      </p>
                                      <p>
                                        Tổng tiền:{" "}
                                        {item?.totalPrice?.toLocaleString("vi")}{" "}
                                        VNĐ
                                      </p>

                                      <p>
                                        Kho nhận hàng:{" "}
                                        {parseAddress(
                                          item?.shippingTypeAddress
                                        )}
                                      </p>
                                    </div>
                                  </td>
                                  <td className={styles.itemDetailServicesWrap}>
                                    <div className={styles.itemDetailServices}>
                                      {(item.services && item.services.length > 0) ? item.services.map((svc, svcIdx) => (
                                        <div key={svcIdx} className={styles.serviceBlock}>
                                          <div className={styles.serviceType}>
                                            {svc.donationType === "normal" ? "🎁 Cho tặng"
                                              : svc.donationType === "recycle" ? "♻️ Tái chế"
                                              : svc.donationType === "zero_waste" ? "🌿 Zero Waste"
                                              : svc.donationType || "Dịch vụ"}
                                            {(() => {
                                              const pt = svc.packageType || (svc as any).package_type;
                                              const pId = (svc as any).packageTypeId || (svc as any).packageTypeID;
                                              let label = "";
                                              
                                              if (pt) {
                                                label = PACKAGE_TYPE.find((p: any) => p.packageType === pt)?.label || pt;
                                              } else if (pId) {
                                                // Fallback to searching in PACKAGE_TYPE_VER_2 by id
                                                label = PACKAGE_TYPE_VER_2.find((p: any) => p.packageTypeId === pId)?.label || pId;
                                              }
                                              
                                              if (label) {
                                                return <span style={{ fontWeight: "normal", fontSize: "0.9rem", color: "#555", marginLeft: "10px" }}>(Trọng lượng: {label})</span>;
                                              }
                                              return null;
                                            })()}
                                          </div>
                                          {svc.donationForms && svc.donationForms.length > 0 && (
                                            <ul className={styles.donationForms}>
                                              {svc.donationForms
                                                .filter((form: any) => {
                                                  const allowed = ALLOWED_DONATION_FORMS[svc.donationType || "normal"];
                                                  return !allowed || allowed.includes(form);
                                                })
                                                .map((form: any, fIdx: any) => (
                                                  <li key={fIdx}>{parseDonationForm(form) || form}</li>
                                              ))}
                                            </ul>
                                          )}
                                          {svc.buyProducts && svc.buyProducts.length > 0 && (
                                            <div className={styles.buyProducts}>
                                              {svc.buyProducts.map((prod, pIdx) => (
                                                <div key={pIdx} className={styles.productRow}>
                                                  {prod.image && <img src={prod.image} alt={prod.name} className={styles.productImg} />}
                                                  <div className={styles.productInfo}>
                                                    <span className={styles.productName}>{prod.name}</span>
                                                    <span className={styles.productPrice}>x{prod.quantity} – {prod.price?.toLocaleString("vi")}đ</span>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                          {svc.donationAmount > 0 && (
                                            <div className={styles.donationAmount}>
                                              ✔ Đồng hành cùng REshare: {svc.donationAmount?.toLocaleString("vi")}đ
                                            </div>
                                          )}
                                          {svc.zeroWastePrice > 0 && (
                                            <div className={styles.zeroWastePrice}>
                                              Phí xử lý: {svc.zeroWastePrice?.toLocaleString("vi")}đ
                                            </div>
                                          )}
                                        </div>
                                      )) : (
                                        <div className={styles.serviceBlock}>
                                          {item.donationForms && item.donationForms.length > 0 && (
                                            <ul className={styles.donationForms}>
                                              {item.donationForms
                                                .filter((form: any) => {
                                                  const allowed = ALLOWED_DONATION_FORMS[(item as any).donationType || "normal"];
                                                  return !allowed || allowed.includes(form);
                                                })
                                                .map((form: string, fIdx: number) => (
                                                  <li key={fIdx}>{parseDonationForm(form) || form}</li>
                                              ))}
                                            </ul>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                  <td className={styles.itemDetailBagsWrap}>
                                    <div className={styles.itemDetailBags}>
                                      {Array.from(new Set([
                                        ...(item.items?.picture || []),
                                        ...(item.services && item.services.length > 0
                                          ? item.services.flatMap((svc: any) => svc.items?.picture || [])
                                          : [])
                                      ])).map((pic: any, pIdx: number) => (
                                        <img key={pIdx} src={pic} alt="Túi đồ" className={styles.bagImg} />
                                      ))}
                                    </div>
                                  </td>
                                  <td style={{ verticalAlign: "top", padding: "12px", minWidth: 160 }}>
                                    {(() => {
                                      let proof: any = null;
                                      try {
                                        const storedProofs = JSON.parse(localStorage.getItem("order_delivery_proofs") || "{}");
                                        proof = storedProofs[item.id];
                                      } catch (e) {}

                                      if (!proof?.pickupImage && !proof?.deliveryImage) {
                                        return <span style={{ color: "#94a3b8", fontSize: 13, fontStyle: "italic" }}>Chưa có ảnh</span>;
                                      }

                                      return (
                                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                                          {proof.pickupImage && (
                                            <div>
                                              <span style={{ fontSize: 11, fontWeight: "bold", color: "#16a34a", display: "block", marginBottom: 3 }}>
                                                📸 Ảnh nhận hàng:
                                              </span>
                                              <a href={proof.pickupImage} target="_blank" rel="noreferrer">
                                                <img
                                                  src={proof.pickupImage}
                                                  alt="Nhận hàng"
                                                  style={{
                                                    maxWidth: 120,
                                                    maxHeight: 90,
                                                    borderRadius: 6,
                                                    objectFit: "cover",
                                                    border: "1px solid #16a34a",
                                                  }}
                                                />
                                              </a>
                                            </div>
                                          )}
                                          {proof.deliveryImage && (
                                            <div>
                                              <span style={{ fontSize: 11, fontWeight: "bold", color: "#2563eb", display: "block", marginBottom: 3 }}>
                                                📦 Ảnh trả hàng (Kho/Trạm):
                                              </span>
                                              <a href={proof.deliveryImage} target="_blank" rel="noreferrer">
                                                <img
                                                  src={proof.deliveryImage}
                                                  alt="Trả hàng"
                                                  style={{
                                                    maxWidth: 120,
                                                    maxHeight: 90,
                                                    borderRadius: 6,
                                                    objectFit: "cover",
                                                    border: "1px solid #2563eb",
                                                  }}
                                                />
                                              </a>
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })()}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  );
                })
              ) : loading ? (
                <tr>
                  <td className={styles.noneData} colSpan={6}>
                    <div className={styles.loadingWrap}>
                      <Loading />
                    </div>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td className={styles.noneData} colSpan={6}>
                    Không có dữ liệu
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <ModalAddBag
        open={open}
        handleClose={handleClose}
        setOpen={setOpen}
        setDataAddBag={setDataAddBag}
        dataAddBag={dataAddBag}
        handleAddBag={handleAddBag}
      />
      <ModalUpdatePaymentStatus
        open={isOpenUpdatePayment}
        setDataUpdatePayment={setDataUpdatePayment}
        dataUpdatePayment={dataUpdatePayment}
        handleClose={handleCloseUpdatePayment}
        handleUpdatePaymentStatus={handleUpdatePaymentStatus}
      />

      <ModalUpdateNote
        open={isOpenUpdateNote}
        handleClose={() => setIsOpenUpdateNote(false)}
        dataUpdateNote={dataUpdateNote}
        setDataUpdateNote={setDataUpdateNote}
        handleReload={reload}
      />
    </div>
  );
};

export default OrderList;
